import {
  LOGIN_RES,
  IS_LOGIN,
  FORGET_PASSWORD,
  LOGIN_MESSAGE,
  IN_PROCESS,
  SHOW_RESET_PASSWORD_FORM,
  LOGIN_WITH_GOOGLE,
} from "../../helpers/constants";
import {
  login,
  recoverPassword,
  setPassword,
  verifyToken,
  googleAuth,
} from "../../api/user/user-api";
import { setToken, setUser, toast } from "../../helpers/utility";
import { BASE_URL } from "../../api/constants";
require("es6-promise").polyfill();
const Joi = require("@hapi/joi");

export function LoginAction(data) {
  return async function (dispatch) {
    dispatch({
      type: IN_PROCESS,
      payload: true,
    });
    dispatch({
      type: LOGIN_MESSAGE,
      payload: "",
    });
    let res;
    try {
      res = await login({ data });
    } catch (error) {
      dispatch({ type: IN_PROCESS, payload: false });
      toast("Sign in failed. Check your connection and try again.", "error");
      return { status: false, msg: "Sign in failed. Check your connection and try again." };
    }
    console.log(res.data.message);
    dispatch({
      type: IN_PROCESS,
      payload: false,
    });
    if (res.data.error || res.data.dbError) {
      toast(res.data.error || res.data.dbError, "error");
    } else if (res.data.is_expire) {
      toast(
        "Password is expired kindly check your mail to reset your password.",
        "error"
      );
    } else if (res.data.isBlocked) {
      toast(
        "Your account is blocked for attempting too many failed attemps. Kindly Check your provided email.",
        "error"
      );
    } else if (res.data.active) {
      if (res.data.usertype === "external") {
        setUser(res.data);
        setToken(res.data.token);
        dispatch({
          type: LOGIN_RES,
          payload: res.data,
        });
        dispatch({
          type: IS_LOGIN,
          payload: true,
        });
        dispatch({
          type: LOGIN_MESSAGE,
          payload: "Success",
        });
      } else {
        setUser(res.data);
        var next = window.location.href.split("login?");
        if (next.length == 2 && next[1].indexOf("next") > -1) {
          // console.log('Next Route',next);
          next = next[1].split("next=")[1];
          // console.log('Next Route final',next);
          window.location = BASE_URL + next;
        } else {
          window.location = BASE_URL + "/order-search";
        }
        // window.location = BASE_URL + "/order-search";
      }
    }
    return { status: Boolean(res.data.active), msg: res.data.message };
  };
}

export function googleAction(data) {
  return async function (dispatch) {
    const schema = Joi.object()
      .keys({
        iss: Joi.string(),
        aud: Joi.string(),
        sub: Joi.string(),
        email: Joi.string()
          .email({ tlds: { allow: false } })
          .required(),
        name: Joi.string().optional(),
      })
      .unknown(true);
    const response = schema.validate(data);
    if (response.error) {
      toast(response.error, "error");
      return { status: false, msg: response.error.message };
    } else {
      const res = await googleAuth({ response });
      if (res.data.error || res.data.dbError) {
        toast(res.data.error || res.data.dbError, "error");
        return { status: false, msg: res.data.error || res.data.dbError };
      } else if (res.data.active) {
        if (res.data.usertype === "external") {
          setUser(res.data);
          setToken(res.data.token);
          dispatch({
            type: LOGIN_RES,
            payload: res.data,
          });
          dispatch({
            type: IS_LOGIN,
            payload: true,
          });
          dispatch({
            type: LOGIN_MESSAGE,
            payload: "Success",
          });
        } else {
          // return
          await setUser(res.data);
          await setToken(res.data.token);
          var next = window.location.href.split("login?");
          if (next.length == 2 && next[1].indexOf("next") > -1) {
            next = next[1].split("next=")[1];
            window.location = BASE_URL + next;
          } else {
            window.location = BASE_URL + "/order-search";
          }
          // window.location = BASE_URL + "/order-search";
        }
        return { status: true };
      } else if (res.data.success === false) {
        toast(res.data.message, "error");
        return { status: false, msg: res.data.message };
      }
      return { status: false, msg: "Google sign in could not be completed." };
    }
  };
}

export function SetPasswordAction(data) {
  return async function (dispatch) {
    dispatch({
      type: IN_PROCESS,
      payload: true,
    });
    dispatch({
      type: LOGIN_MESSAGE,
      payload: "",
    });
    try {
      const res = await setPassword(data);
      if (!res.data.status) toast(res.data.msg, "error");
      return res.data;
    } catch (error) {
      return { status: false, msg: "We couldn't update your password. Check your connection and try again." };
    } finally {
      dispatch({ type: IN_PROCESS, payload: false });
    }
  };
}

export function VerifyToken(data) {
  return async function (dispatch) {
    dispatch({
      type: IN_PROCESS,
      payload: true,
    });
    dispatch({
      type: LOGIN_MESSAGE,
      payload: "",
    });
    const res = await verifyToken(data);
    console.log(res.data);
    // if(res.data.status)
    dispatch({
      type: SHOW_RESET_PASSWORD_FORM,
      payload: res.data.status,
    });
    return res.data;
  };
}

export function RecoverPasswordAction(data) {
  return async function (dispatch) {
    dispatch({
      type: IN_PROCESS,
      payload: true,
    });
    dispatch({
      type: LOGIN_MESSAGE,
      payload: "",
    });
    try {
      const res = await recoverPassword(data);
      return res.data;
    } catch (error) {
      return { status: false, msg: "We couldn't send reset instructions. Check your connection and try again." };
    } finally {
      dispatch({ type: IN_PROCESS, payload: false });
    }
  };
}
